function resize() {

    console.log('lifecycle :', 'resize splash scene');
}

export {resize};
